import { render, staticRenderFns } from "./header-search.vue?vue&type=template&id=3d15d6d3&scoped=true"
import script from "./header-search.vue?vue&type=script&lang=js"
export * from "./header-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15d6d3",
  null
  
)

export default component.exports